import { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { rulesData } from '../data/rulesData'

import './rules.css'

import AOS from 'aos';

import 'aos/dist/aos.css';

import Navbar from '../components/Navbar';
import Accordion from '../components/Accordion';
import Footer from '../components/Footer';

const Rules = () => {

  useEffect(() => {
    AOS.init({
      duration: 2000,
      once: true,
      easing: "ease-out-cubic"
    })
  })

  return (
    <div className="rules-container">
      <Helmet>
        <title>Regolamento</title>
        <meta property="og:Regolamento" content="Regolamento evento" />
      </Helmet>
      <Navbar />
      <h1 className="rulesTitle Section-Heading">LE NOSTRE REGOLE UFFICIALI</h1>
      <div className="rules-wrap" >
          <div className="tri tri-right" />
          <div className="tri tri-left" />
          <img src={"./assets/karateka.png"} className="side-karateka" alt="karateka" data-aos="fade-up-left" data-aos-duration="2000" data-aos-delay="2000" />
          <Accordion items={rulesData} keepOthersOpen={true}/>
          <div className="download-rules-container" >
              <a href="/files/REGOLAMENTO_UFFICIALE_ARENA.pdf" download className="download-rules-text">Scarica PDF qui!</a>
          </div>
      </div>
      <Footer />
    </div>
  )
}

export default Rules

